import { view } from "@risingstack/react-easy-state";
import { Select } from "@tine/designsystem-ui-react";
import { sendFilter } from "../../common/tracking";
import type { FilterSettings, LegalFilterKey } from "../../common/types/productTypes";
import { translateFilterValue } from "../../common/utils/filterUtils";
import productStore from "../../stores/product/productStore";
import MultiSelect, { type MultiSelectChangePayload } from "../common/MultiSelect";

type FilterSelectionOptionsProps = {
   filters: FilterSettings[];
   onFilterChange: (e: React.ChangeEvent<HTMLInputElement>, field: LegalFilterKey, value: string, isRadio: boolean) => void;
};
type Option = {
   value: string;
   label: string;
};
type FilterSelectionOptionProps = {
   filterSettings: FilterSettings;
   onFilterChange: (e: React.ChangeEvent<HTMLInputElement>, field: LegalFilterKey, value: string, isRadio: boolean) => void;
};

const FilterSelectionSingleOption = view(({ filterSettings }: FilterSelectionOptionProps) => {
   const { field } = filterSettings;
   const name = translateFilterValue(filterSettings.field, filterSettings.name);
   const optionValues = Object.keys(filterSettings.options);
   const options = optionValues.map((value) => ({ value: value, label: translateFilterValue(field, value) }));

   const activeOption = options.find((o) => productStore.isFilterActive(field, o.value));
   const value = activeOption
      ? activeOption
      : filterSettings.radioDefault
        ? { value: filterSettings.radioDefault, label: translateFilterValue(field, filterSettings.radioDefault) }
        : { value: "", label: "" };

   const handleChange = (value: Option) => {
      if (value.value) {
         productStore.clearFilterFields([field]);
         sendFilter(field, value.value);
         productStore.addFilterValue(field, value.value);
      }
   };

   return <Select options={options} label={name} value={value} onChange={handleChange} />;
});

const FilterSelectionMultiOption = view(({ filterSettings }: FilterSelectionOptionProps) => {
   const { field } = filterSettings;
   const name = translateFilterValue(filterSettings.field, filterSettings.name);

   const optionValues = filterSettings.values;

   const options = optionValues.map((value) => ({ name: value, label: translateFilterValue(field, value) }));
   const selected = options.filter((option) => productStore.isFilterActive(field, option.name)).map((option) => option.name);
   const handleChange = (payload: MultiSelectChangePayload) => {
      if (payload.value) {
         sendFilter(field, payload.name);
         productStore.addFilterValue(field, payload.name);
      } else {
         productStore.removeFilterValue(field, payload.name);
      }
   };
   return <MultiSelect name={name} label="" options={options} selected={selected} onChange={handleChange} />;
});

const FilterSelectionOptions = ({ filters, onFilterChange }: FilterSelectionOptionsProps) => {
   return (
      <>
         {filters.map((filter) =>
            Object.keys(filter.options).length > 0 ? (
               filter.radioDefault ? (
                  <div key={filter.name}>
                     <FilterSelectionSingleOption filterSettings={filter} onFilterChange={onFilterChange} />
                  </div>
               ) : (
                  <div key={filter.name}>
                     <FilterSelectionMultiOption filterSettings={filter} onFilterChange={onFilterChange} />
                  </div>
               )
            ) : null
         )}
      </>
   );
};

export default view(FilterSelectionOptions);
